import { render } from "./circle-animation.vue?vue&type=template&id=7d97ed74&scoped=true"
const script = {}

import "./circle-animation.vue?vue&type=style&index=0&id=7d97ed74&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d97ed74"]])

export default __exports__